(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hola-collection-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hola-coffee-card')) {
  customElements.define('hola-coffee-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-coffee-data]');
      this.form = this.querySelector('form');
      this.size = this.querySelector('[data-coffee-size]');
      this.grind = this.querySelector('[data-coffee-grind]');
      this.price = this.querySelector('[data-coffee-price]');
      this.add = this.querySelector('[data-coffee-add]');
      this.addLabel = this.querySelector('[data-coffee-add-label]');
      this.status = this.querySelector('[data-coffee-status]');
      this.error = this.querySelector('[data-coffee-error]');
      const controls = this.querySelector('[data-coffee-controls]');
      const fallback = this.querySelector('[data-coffee-fallback]');
      if (!source || !this.form || !this.size || !this.grind || !this.price || !this.add || !this.addLabel || !this.status || !this.error || !controls || !fallback) return;
      try {
        this.products = JSON.parse(source.textContent);
        if (!Array.isArray(this.products) || !this.products.length || this.products.some(product => !Array.isArray(product.variants))) return;
      } catch (_) {
        return;
      }
      this.initialized = true;
      this.size.addEventListener('change', () => this.updateGrinds());
      this.grind.addEventListener('change', () => this.updateVariant());
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.updateGrinds();
      controls.hidden = false;
      fallback.hidden = true;
    }
    normalize(value) {
      return String(value || '').toLowerCase().trim().replace(/\s+/g, ' ');
    }
    canBuy(variant) {
      return Boolean(variant?.available && !variant.requiresSellingPlan && /^\d+$/.test(String(variant.id)));
    }
    updateGrinds() {
      const previousTitle = this.normalize(this.grind.selectedOptions[0]?.dataset.variantTitle || this.grind.selectedOptions[0]?.textContent);
      const initialId = this.grind.value;
      const product = this.products.find(item => item.size === this.size.value);
      const variants = product?.variants || [];
      const selected = variants.find(variant => this.normalize(variant.title) === previousTitle)
        || variants.find(variant => variant.id === initialId)
        || variants.find(variant => this.canBuy(variant))
        || variants[0];
      this.grind.replaceChildren(...variants.map(variant => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.dataset.variantTitle = variant.title;
        option.textContent = this.canBuy(variant) ? variant.title : `${variant.title} · ${variant.available ? this.dataset.unavailableLabel : this.dataset.soldOutLabel}`;
        option.disabled = !this.canBuy(variant);
        option.selected = variant.id === selected?.id;
        return option;
      }));
      this.grind.disabled = !variants.length;
      this.updateVariant();
    }
    updateVariant() {
      const product = this.products.find(item => item.size === this.size.value);
      const variant = product?.variants.find(item => item.id === this.grind.value);
      const available = this.canBuy(variant);
      const state = variant && !variant.available ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
      this.price.textContent = variant?.price || this.dataset.unavailableLabel;
      this.add.disabled = !available || Boolean(this.busy);
      this.addLabel.textContent = this.busy ? this.dataset.loadingLabel : available ? this.dataset.addLabel : state;
      this.status.hidden = available;
      this.status.textContent = available ? '' : state;
      const productId = this.form.querySelector('[name="product-id"]');
      if (productId && product) productId.value = product.id;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      this.updateVariant();
      const product = this.products.find(item => item.size === this.size.value);
      const variant = product?.variants.find(item => item.id === this.grind.value);
      if (!this.canBuy(variant)) return;
      this.busy = true;
      this.error.hidden = true;
      this.error.textContent = '';
      this.add.setAttribute('aria-busy', 'true');
      this.updateVariant();
      let added = false;
      const goToCart = () => location.assign(window.routes?.cart_url || '/cart');
      try {
        const data = new FormData();
        data.set('id', variant.id);
        data.set('quantity', '1');
        const candidate = document.querySelector('cart-drawer');
        const cart = candidate && typeof candidate.getSectionsToRender === 'function' && typeof candidate.setActiveElement === 'function' && typeof candidate.renderContents === 'function' ? candidate : null;
        const sections = cart ? cart.getSectionsToRender().map(section => section.id) : [];
        if (cart) {
          data.set('sections', sections.join(','));
          data.set('sections_url', location.pathname);
          cart.setActiveElement(this.add);
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        let result;
        try {
          result = await response.json();
        } catch (_) {
          if (response.ok) {
            added = true;
            goToCart();
            return;
          }
          throw new Error(this.dataset.errorLabel);
        }
        if (!response.ok || result?.status) throw new Error(result?.description || this.dataset.errorLabel);
        added = true;
        if (cart && result?.sections && sections.every(id => typeof result.sections[id] === 'string')) {
          cart.classList.remove('is-empty');
          await cart.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hola-collection', productVariantId: variant.id, cartData: result });
          }
        } else {
          goToCart();
        }
      } catch (error) {
        if (added) {
          goToCart();
        } else {
          this.error.textContent = error.message || this.dataset.errorLabel;
          this.error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.add.removeAttribute('aria-busy');
        this.updateVariant();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hola-size-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hola-size-links')) {
    customElements.define('hola-size-links', class extends HTMLElement {
      connectedCallback() {
        if (this.unsubscribe || typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data?.variant?.title || this.closest('product-info')?.dataset.section !== data.sectionId) return;
          this.querySelectorAll('a[data-hola-variants]').forEach((link) => {
            const match = JSON.parse(link.dataset.holaVariants).find((variant) => variant.title === data.variant.title);
            if (!match) return;
            const url = new URL(link.href);
            url.searchParams.set('variant', String(match.id));
            link.href = url.href;
          });
        });
      }
      disconnectedCallback() { this.unsubscribe?.(); this.unsubscribe = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
